<app-loader [Parent]="this"></app-loader>

@if (Lane) {
  <div class="lane-diagnostics-container">
    <div class="columns is-mobile mb-0">
      <div class="column pb-0">
        <div class="lane-header section-title">
          <h1>{{Lane.ParkingLotName}} - {{Lane.Name}}</h1>
        </div>
      </div>
    </div>
    <div class="columns pb-5">
      <div class="column is-one-quarter">
        <div class="section-header">
          <h1 class="section-title">Sessions</h1>
          <div class="header-controls">
            <div class="live-switcher">
              <label class="switch">
                <input type="checkbox"
                  [ngModel]="autoFollowSessions"
                  (ngModelChange)="setAutoFollow($event)">
                  <span class="slider">
                    @if (autoFollowSessions) {
                      <span class="live-indicator"></span>
                      Auto-follow
                    }
                    @if (!autoFollowSessions) {
                      Manual
                    }
                  </span>
                </label>
              </div>
            </div>
          </div>
          <div class="card scrollable-container frog-scrollbar">
            @if (isLoadingSessions) {
              <div class="loading-container">
                <div class="spinner froggreen"></div>
              </div>
            }
            @if (!isLoadingSessions) {
              <div>
                @for (session of sessions; track session) {
                  <div
                    class="list-item"
                    [ngClass]="{ 'selected' : selectedSession == session.SessionKey}"
                    (click)="selectSession(session.SessionKey)">
                    <div class="item-content">
                      <div class="secondary-text">
                        {{session.ArrivalAtGateTime | date:'mediumTime'}}
                        @if (session.IsImported) {
                          <span
                            class="imported-indicator"
                            title="Imported Session">
                            <i class="fas fa-file-import"></i>
                          </span>
                        }
                      </div>
                      <div class="info-row">
                        @if (session.PlateNumber) {
                          <span class="info-row-title">{{session.PlateNumber}}</span>
                        }
                        @if (!session.PlateNumber) {
                          <span class="info-row-title-small">
                            @if (session === sessions[0]) {
                              Pending plate...
                            }
                            @if (session !== sessions[0]) {
                              Click to load
                            }
                          </span>
                        }
                        <span class="info-row-activity">{{session.SessionKey}}</span>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="column is-half">
          <div class="columns pb-5">
            <div class="column is-half">
              <div class="section-header">
                <h1 class="section-title">Session Details</h1>
                <div class="header-controls">
                  <input type="file"
                    #fileInput
                    style="display: none;"
                    accept=".json"
                    (change)="importSession($event)">
                    <button class="button is-small mr-2"
                      (click)="fileInput.click()"
                      title="Import session from file">
                      <span class="icon">
                        <i class="fas fa-upload"></i>
                      </span>
                    </button>
                    <button class="button is-small"
                      [disabled]="!currentLoadedSession"
                      (click)="downloadSession()"
                                [title]="currentLoadedSession?.IsLive ? 
                                        'Download will start when session completes' : 
                                        'Download session data'">
                      <span class="icon">
                        <i class="fas fa-download"></i>
                      </span>
                    </button>
                  </div>
                </div>
                <div class="card">
                  @if ((isLoadingSessionDetails && selectedSession != undefined) || isLoadingSessions) {
                    <div class="loading-container">
                      <div class="spinner froggreen"></div>
                    </div>
                  }
                  @if (!isLoadingSessions && selectedSession == undefined) {
                    <div class="no-image-placeholder">
                      <p>Please select a session to view details</p>
                    </div>
                  }
                  @if (!isLoadingSessionDetails && selectedSession != undefined) {
                    <div>
                      <div class="panel-block detail-row">
                        @if (currentLoadedSession.ProcessingStarted || !currentLoadedSession.IsLive) {
                          <span class="label">Time at Gate</span>
                        }
                        @if (!currentLoadedSession.ProcessingStarted && currentLoadedSession.IsLive) {
                          <span class="label">Idle time</span>
                        }
                        <span class="value">{{SecondsToUsefulTime(currentLoadedSession.TimeAtGate)}} <span class="is-size-7">(Since {{currentLoadedSession.ArrivalAtGateTime | date:'mediumTime'}})</span></span>
                      </div>
                      <div class="panel-block detail-row">
                        <span class="label">Plate Number</span>
                        <span class="value">{{currentLoadedSession.PlateNumber}}</span>
                      </div>
                      <div class="panel-block detail-row">
                        <span class="label">Rate Set</span>
                        <span class="value">{{currentLoadedSession.RateSetName}}</span>
                      </div>
                      <div class="panel-block detail-row">
                        <span class="label">
                          @if (!currentLoadedSession.EntryDate || isEntryBeforeArrival(currentLoadedSession.EntryDate, currentLoadedSession.ArrivalAtGateTime)) {
                            Session Duration
                          }
                          @if (currentLoadedSession.EntryDate && !isEntryBeforeArrival(currentLoadedSession.EntryDate, currentLoadedSession.ArrivalAtGateTime)) {
                            Entry Date
                          }
                        </span>
                        <span class="value">
                          @if (currentLoadedSession.EntryDate) {
                            @if (isEntryBeforeArrival(currentLoadedSession.EntryDate, currentLoadedSession.ArrivalAtGateTime)) {
                              {{getDurationFromEntry(currentLoadedSession.EntryDate, currentLoadedSession.ArrivalAtGateTime)}}
                              <span class="is-size-7">(Entry: {{currentLoadedSession.EntryDate | date:'mediumTime'}})</span>
                            }
                            @if (!isEntryBeforeArrival(currentLoadedSession.EntryDate, currentLoadedSession.ArrivalAtGateTime)) {
                              {{currentLoadedSession.EntryDate | date:'medium'}}
                            }
                          }
                        </span>
                      </div>
                      <div class="panel-block detail-row">
                        <span class="label">Session Key</span>
                        <span class="value is-size-7">{{currentLoadedSession.SessionKey}}</span>
                      </div>
                    </div>
                  }
                </div>
              </div>
              <div class="column is-half">
                <div class="section-header">
                  <h1 class="section-title">Camera & Screens</h1>
                </div>
                <div class="card">
                  @if ((isLoadingSessionDetails && selectedSession != undefined) || isLoadingSessions) {
                    <div class="loading-container">
                      <div class="spinner froggreen"></div>
                    </div>
                  }
                  @if (!selectedSession && !isLoadingSessions) {
                    <div class="no-image-placeholder">
                      <p>Please select a session to view images</p>
                    </div>
                  }
                  @if (selectedSession && currentLoadedSession) {
                    <div>
                      @if (currentLoadedSession.images?.length > 0) {
                        <div class="image-container">
                          <img [src]="'data:image/jpeg;base64,' + getSelectedImage()" alt="Selected Image">
                          <button class="expand-button" (click)="fetchAndShowImageModal()">
                            <i class="fas fa-expand"></i>
                          </button>
                        </div>
                      }
                      @if (currentLoadedSession.images?.length > 0) {
                        <div class="thumbnails-container">
                          @for (image of currentLoadedSession.images; track image; let i = $index) {
                            <div
                              class="thumbnail"
                              [ngClass]="{'selected': selectedImageId === image.ImageId}"
                              (click)="selectImage(image.ImageId)">
                              <div class="image-type-indicator" [ngClass]="image.ImageType">
                                <i [class]="image.ImageType === 'CameraSnapshot' ? 'fas fa-car' : 'fas fa-desktop'"></i>
                              </div>
                              <img [src]="'data:image/jpeg;base64,' + image.Bytes" [alt]="image.ImageType + ' image'">
                            </div>
                          }
                        </div>
                      }
                      @if (!currentLoadedSession.images?.length) {
                        <div class="no-image-placeholder">
                          @if (currentLoadedSession.IsLive) {
                            <div class="bouncing-dots">
                              <div class="dot"></div>
                              <div class="dot"></div>
                              <div class="dot"></div>
                            </div>
                            <p class="mt-3">Waiting for images...</p>
                          }
                          @if (!currentLoadedSession.IsLive) {
                            <i class="fas fa-image-slash"></i>
                            <p>No images found</p>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="workflows">
              <div class="section-header">
                <h1 class="section-title">Workflow</h1>
                <div class="header-controls">
                  <button class="button is-small"
                    (click)="confirmForceHome()"
                    [disabled]="!currentLoadedSession?.IsLive"
                    title="Force workflow back to home state">
                    <span class="icon">
                      <i class="fas fa-house"></i>
                    </span>
                  </button>
                </div>
              </div>
              <div class="card frog-scrollbar">
                <app-workflowviewer [workflow]="getCurrentWorkflow()" [useCasePath]="currentLoadedSession?.StateEvents" [changeCounter]="stateEventCounter"></app-workflowviewer>
              </div>
            </div>
            <div class="events">
              <div class="section-header">
                <h1 class="section-title">Events</h1>
              </div>
              <div class="card">
                @if ((isLoadingSessionDetails && selectedSession != undefined) || isLoadingSessions) {
                  <div class="loading-container">
                    <div class="spinner froggreen"></div>
                  </div>
                }
                @if (!isLoadingSessions && selectedSession == undefined) {
                  <div class="no-image-placeholder">
                    <p>Please select a session to view events</p>
                  </div>
                }
                @if (!isLoadingSessionDetails) {
                  <div>
                    @if (currentLoadedSession.DebugEvents.length == 0) {
                      <div>
                        <div class="p-4 m-4"><i>No recorded events.</i></div>
                      </div>
                    }
                    @if (currentLoadedSession.DebugEvents.length > 0) {
                      <div class="event-list frog-scrollbar">
                        @for (event of currentLoadedSession.DebugEvents; track event; let even = $even) {
                          <div class="event-row"
                            [ngClass]="{'even': even}">
                            <div class="event-timestamp">
                              {{event.TimeStamp | date:'mediumTime'}}
                            </div>
                            <div class="event-device">
                              <div class="event-device-type">{{event.DeviceType}}</div>
                              @if (event.DeviceIdentifier) {
                                <div class="event-device-identifier">{{event.DeviceIdentifier}}</div>
                              }
                            </div>
                            <div class="event-details">
                              <div class="event-name">{{event.EventName}}</div>
                              @if (event.EventDescription) {
                                <div class="event-description">{{event.EventDescription}}</div>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="column is-one-quarter">
            <div class="section-header">
              <h1 class="section-title">
                Devices
                @if (currentLoadedSession && !currentLoadedSession.IsLive && currentLoadedSession.DevicesSnapshotTime) {
                  <span class="snapshot-time">(as at {{currentLoadedSession.DevicesSnapshotTime | date:'medium'}})</span>
                }
              </h1>
              <div class="header-controls">
                @if (currentLoadedSession?.IsLive) {
                  <div class="live-switcher">
                    <label class="switch">
                      <input type="checkbox"
                        [(ngModel)]="isLiveMode"
                        [disabled]="!selectedSession || currentLoadedSession?.IsLive">
                        <span class="slider">
                          @if (isLiveMode) {
                            <span class="live-indicator"></span>
                            Live
                          }
                          @if (!isLiveMode) {
                            <i class="fas fa-camera"></i>
                            Snapshot
                          }
                        </span>
                      </label>
                    </div>
                  }
                </div>
              </div>
              <div class="card scrollable-container frog-scrollbar">
                @for (device of getDevicesToShow(); track device) {
                  <div
                    class="list-item device-item"
                    [class.expanded]="expandedDevices.has(device.DeviceId)"
                    (click)="toggleDevice(device.DeviceId)">
                    <div class="item-content">
                      <div class="status-indicator">
                        <span class="status-dot"
                              [ngClass]="{
                                'good': device.Status === 'Connected',
                                'degraded': device.Status === 'Degraded',
                                'offline': device.Status === 'Offline',
                                'syncing': device.Status === 'Syncing',
                                'unknown': !['Connected', 'Degraded', 'Offline', 'Syncing'].includes(device.Status)
                              }">
                        </span>
                        <span class="connection-status">{{device.Status ?? 'Unknown'}}</span>
                      </div>
                      <div class="info-row">
                        <span class="info-row-title">{{device.DeviceType}}</span>
                        @if (device.CurrentActivity) {
                          <span class="info-row-activity">
                            {{device.CurrentActivity.charAt(0).toUpperCase() + device.CurrentActivity.slice(1)}}
                          </span>
                        }
                      </div>
                      <div class="device-details">
                        @if (device.Name) {
                          <div class="detail-item">
                            <span class="detail-label">Name:</span>
                            <span class="detail-value">{{device.Name}}</span>
                          </div>
                        }
                        @if (device.ConnectionStatus) {
                          <div class="detail-item">
                            <span class="detail-label">Connection:</span>
                            <span class="detail-value">{{device.ConnectionStatus}}</span>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="modal" [class.is-active]="showOfflineModal">
            <div class="modal-background"></div>
            <div class="modal-content">
              <div class="box">
                <i class="fas fa-wifi-slash fa-2x has-text-danger mb-3"></i>
                <h1 class="title is-4 has-text-danger">Controller failed to respond</h1>
                <p>The lane controller has not responded within the expected timeframe. There may be an issue with communications or power.</p>
                <p class="has-text-grey mt-2">You may need to restart the controller or contact support if the issue persists.</p>
              </div>
            </div>
          </div>
          <div class="modal" [class.is-active]="showImageModal">
            <div class="modal-background" (click)="showImageModal = false"></div>
            <div class="modal-content">
              <div class="image-modal-container">
                <img [src]="'data:image/jpeg;base64,' + getSelectedImage()" alt="Full size image">
              </div>
            </div>
            <button class="modal-close is-large" aria-label="close" (click)="showImageModal = false"></button>
          </div>
          <div class="modal" [class.is-active]="showInactivityModal">
            <div class="modal-background"></div>
            <div class="modal-content">
              <div class="box">
                <i class="fas fa-clock fa-2x has-text-warning mb-3"></i>
                <h1 class="title is-4">Are you still there?</h1>
                <p>This session will expire in {{countdownSeconds}} seconds due to inactivity.</p>
                <p class="has-text-grey mt-2">Click anywhere or move your mouse to continue.</p>
              </div>
            </div>
          </div>
          <div class="modal" [class.is-active]="showExpiredModal">
            <div class="modal-background"></div>
            <div class="modal-content">
              <div class="box">
                <i class="fas fa-triangle-exclamation fa-2x has-text-danger mb-3"></i>
                <h1 class="title is-4">Session Expired</h1>
                <p>Your session has expired due to inactivity.</p>
                <p class="has-text-grey mt-2">Please refresh the page to continue.</p>
                <button class="button is-primary mt-4" onclick="window.location.reload()">
                  <span class="icon">
                    <i class="fas fa-arrows-rotate"></i>
                  </span>
                  <span>Refresh Page</span>
                </button>
              </div>
            </div>
          </div>
          <div class="modal" [class.is-active]="showForceHomeModal">
            <div class="modal-background"></div>
            <div class="modal-content">
              <div class="box">
                <i class="fas fa-triangle-exclamation fa-2x has-text-warning mb-3"></i>
                <h1 class="title is-4">Confirm Force Home</h1>
                <p>Are you sure you want to force the workflow back to its home state? This should only be used when the workflow is stuck.</p>
                <div class="buttons mt-4 is-justify-content-flex-end">
                  <button class="button" (click)="showForceHomeModal = false">
                    Cancel
                  </button>
                  <button class="button is-warning countdown-button" [ngClass]="{'animating': forceHomeCountdown > 0}"
                    [disabled]="forceHomeCountdown > 0"
                    (click)="executeForceHome()">
                    <span>Force Home</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      }